import React from 'react'
import PropTypes from 'prop-types'
import { get, orderBy, reduce } from 'lodash'
import BookingForm from './BookingForm'
import { useMediaQuery } from '@uidotdev/usehooks'
import useCustomEndpoint, { VALID_ENDPOINTS } from '@/hooks/useCustomEndpoint'
// styles
import './styles.bh.scss'

BookingHotel.propTypes = {
  data: PropTypes.object,
}
export default function BookingHotel({ data }) {
  const { data: allDataHotels, loading: allLoading } = useCustomEndpoint({
    type: VALID_ENDPOINTS.bookingEngine,
  })

  const isMobile = useMediaQuery('only screen and (max-width: 640px)')
  const bgUrlMobile = `${get(data, ['backgroundImageMobile', 'url'], '')}`
  const bgUrlDesktop = `${get(data, ['backgroundImage', 'url'], '')}`

  const getHotels = () => {
    if (!allDataHotels) return []

    const _data = reduce(
      allDataHotels,
      (acc, item) => {
        acc.push({
          value: get(item, ['bookingEngine', 'id'], ''),
          label: get(item, ['select_label'], ''),
          acf: {
            bookingEngine: { ...get(item, ['bookingEngine'], '') },
          },
        })
        return acc
      },
      [],
    )

    const orderedData = orderBy(_data, ['order'], ['asc'])

    return orderedData
  }

  const _props = {
    data: {
      ...data,
      hotelList: getHotels(),
      hotelLoading: allLoading,
    },
    style: {
      backgroundImage: isMobile ? `url(${bgUrlMobile})` : `url(${bgUrlDesktop})`,
    },
  }

  return (
    <section className="containerSectionBH" style={{ ..._props.style }}>
      <BookingForm data={get(_props, 'data', null)} />
    </section>
  )
}
